{
  "id": "straightLineSled",
  "name": "Straight-Line Sled",
  "builds": "tool",
  "category": "jigs",
  "note": "A straight edge for boards that don't have one.",
  "skill": "jigsAndFixtures",
  "duration": 30,
  "offeredBy": "bench",
  "fastener": "screws",
  "widthIn": 48,
  "heightIn": 24,
  "slots": [
    {
      "id": "base-0",
      "role": "base",
      "part": {
        "widthIn": 48,
        "lengthIn": 16,
        "thicknessQ": 3
      },
      "stock": {
        "type": "plywood",
        "sheetGrade": "jig",
        "thickness": "any"
      },
      "xIn": 24,
      "yIn": 12,
      "angleDeg": 0,
      "zIn": 0
    },
    {
      "id": "rail-0",
      "role": "rail",
      "part": {
        "widthIn": 4,
        "lengthIn": 36,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board"
      },
      "xIn": 24,
      "yIn": 7,
      "angleDeg": 90,
      "zIn": 0.75
    },
    {
      "id": "rail-1",
      "role": "rail",
      "part": {
        "widthIn": 4,
        "lengthIn": 36,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board"
      },
      "xIn": 24,
      "yIn": 17,
      "angleDeg": 90,
      "zIn": 0.75
    }
  ],
  "fasteners": [
    {
      "xIn": 15,
      "yIn": 7
    },
    {
      "xIn": 33,
      "yIn": 7
    },
    {
      "xIn": 15,
      "yIn": 17
    },
    {
      "xIn": 33,
      "yIn": 17
    }
  ]
}
